'use client';

import { useLenis } from 'lenis/react';
import { useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import analytics from '@/services/analytics';

export const SCROLL_TO_TOP_BUTTON_VISIBLE_TARGET_SCROLL_THRESHOLD = 150;

export const ScrollToTopButton = () => {
    const [visible, setVisible] = useState<boolean>(false);
    const lenis = useLenis(({ targetScroll }) => {
        setVisible(Number(targetScroll) > SCROLL_TO_TOP_BUTTON_VISIBLE_TARGET_SCROLL_THRESHOLD);
    });

    return (
        <Fade in={visible}>
            <Button
                color="primary"
                variant="outlined"
                sx={{
                    position: 'fixed',
                    bottom: 20,
                    left: '50%',
                    transform: 'translate(-50%, 0)',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    padding: 1,
                    height: 48,
                    width: 48,
                    minWidth: 40,
                    outlineOffset: 0,
                    zIndex: 1000,
                }}
                onClick={() => {
                    analytics.plugins.interactions.trackInteraction({
                        source: 'Back to top button',
                        category: 'back-to-top',
                        action: 'click',
                    });
                    lenis?.scrollTo(0);
                }}
            >
                <KeyboardArrowUpIcon />
            </Button>
        </Fade>
    );
};
